// extracted by mini-css-extract-plugin
module.exports = {"scrollbar-bar":"ScrollbarThumb_scrollbar-bar_LXPGk","scrollbar-thumb":"ScrollbarThumb_scrollbar-thumb_3O_Df","scrollbar":"ScrollbarThumb_scrollbar_2DQbP"};